import React from "react";

const PlaceDetailsShimmer = () => {
  return (
    <div>
    <div className="flex h-40 mb-5">
      <div className="relative w-[30%]">
        <div className="absolute z-[50] ml-[8.5rem] mt-2 text-gray-light text-right cursor-pointer rounded-[10rem] bg-white p-1 hover:bg-red-400">
          <div className="animate-pulse ">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 "
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 4c-2.76 0-5 2.24-5 5 0 3.87 5 8.25 5 8.25S17 12.87 17 9c0-2.76-2.24-5-5-5z"
              />
            </svg>
          </div>
        </div>
        <div className="w-full h-full animate-pulse bg-gray-100"></div>
      </div>

      <div className="w-[70%] ml-4">
        <div className="text-xl mb-1 font-bold animate-pulse bg-gray-200 rounded-sm w-1/2 h-6"></div>
        <div className="flex mb-2 mt-2">
          <div className="w-4 h-3  animate-pulse bg-gray-200 "></div>
          <div className="w-8 ml-4 leading-relaxed animate-pulse bg-gray-200 rounded-sm"></div>
        </div>
        <div className="flex justify-between mb-1">
          <div className="w-20 h-4 animate-pulse bg-gray-200 rounded-sm"></div>
        </div>
       

        <div className="w-1/3 h-4 animate-pulse bg-gray-200 rounded-sm mt-2"></div>

        <div className="w-2/3 h-4 animate-pulse bg-gray-200 rounded-sm mt-4"></div>
        <div className="w-1/5 h-4 animate-pulse bg-gray-200 rounded-sm mt-2"></div>
      </div>
    </div>
    <div className="w-[95%] border-b-2 border-gray-200 mb-5" />
    </div>
  );
};

export default PlaceDetailsShimmer;
